import {SHOW_INTRO} from '../constants/intro';

const initialState = {
  isShowIntro: true,
};

const showIntroReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_INTRO:
      return {
        ...state,
        isShowIntro: action.payload,
      };
    default:
      return state;
  }
};
export default showIntroReducer;
